import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";


const HomeIcon = ({ active }) => (
    <svg
        width="20" height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5192 7.82274C2 8.77128 2 9.91549 2 12.2039V13.725C2 17.6258 2 19.5763 3.17157 20.7881C4.34315 22 6.22876 22 10 22H14C17.7712 22 19.6569 22 20.8284 20.7881C22 19.5763 22 17.6258 22 13.725V12.2039C22 9.91549 22 8.77128 21.4808 7.82274C20.9616 6.87421 20.0131 6.28551 18.116 5.10812L16.116 3.86687C14.1106 2.62229 13.1079 2 12 2C10.8921 2 9.88939 2.62229 7.88403 3.86687L5.88403 5.10813C3.98695 6.28551 3.0384 6.87421 2.5192 7.82274ZM9 17.25C8.58579 17.25 8.25 17.5858 8.25 18C8.25 18.4142 8.58579 18.75 9 18.75H15C15.4142 18.75 15.75 18.4142 15.75 18C15.75 17.5858 15.4142 17.25 15 17.25H9Z"
            fill={active ? '#66a589' : '#69686f'}
        />
    </svg>

);

const SearchIcon = ({ active }) => (
    <svg width="20" height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width={24} height={24} fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C13.125 20 15.078 19.2635 16.6177 18.0319L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L18.0319 16.6177C19.2635 15.078 20 13.125 20 11C20 6.02944 15.9706 2 11 2Z"
            fill={active ? '#66a589' : '#69686f'}
        />
    </svg>
);

const CartIcon = ({ active }) => (
    <svg width="20" height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.25012 7.01346C8.25004 7.00898 8.25 7.00449 8.25 7V6C8.25 3.92893 9.92893 2.25 12 2.25C14.0711 2.25 15.75 3.92893 15.75 6V7C15.75 7.0045 15.75 7.00898 15.7499 7.01346C17.0472 7.04975 17.8375 7.18393 18.4425 7.67997C19.272 8.35995 19.5029 9.5144 19.9646 11.8233L20.5646 14.8233C21.2287 18.1437 21.5608 19.8039 20.6606 20.902C19.7604 22 18.0673 22 14.6812 22H9.3188C5.93262 22 4.23954 22 3.33936 20.902C2.43919 19.8039 2.77123 18.1437 3.43532 14.8233L4.03532 11.8233C4.4971 9.5144 4.72799 8.35995 5.55742 7.67997C6.16251 7.18392 6.95273 7.04975 8.25012 7.01346ZM9.75 6C9.75 4.75736 10.7574 3.75 12 3.75C13.2426 3.75 14.25 4.75736 14.25 6V7C14.25 7 14.25 7 14.25 7C14.1944 6.99999 14.1381 7 14.0812 7H9.9188C9.86185 7 9.80559 7 9.75 7.00001C9.75 7.00001 9.75 7.00001 9.75 7.00001V6ZM12.0004 17.25C11.0219 17.25 10.1874 16.625 9.87821 15.7501C9.74018 15.3595 9.31168 15.1548 8.92115 15.2929C8.53061 15.4309 8.32592 15.8594 8.46395 16.2499C8.97839 17.7054 10.3664 18.75 12.0004 18.75C13.6343 18.75 15.0224 17.7054 15.5368 16.2499C15.6748 15.8594 15.4701 15.4309 15.0796 15.2929C14.6891 15.1548 14.2606 15.3595 14.1225 15.7501C13.8133 16.625 12.9789 17.25 12.0004 17.25Z"
            fill={active ? '#66a589' : '#69686f'}
        />
    </svg>
);

const LikeIcon = ({ active }) => (
    <svg width="20" height="20"

        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2 9.1371C2 14 6.01943 16.5914 8.96173 18.9109C10 19.7294 11 20.5 12 20.5C13 20.5 14 19.7294 15.0383 18.9109C17.9806 16.5914 22 14 22 9.1371C22 4.27416 16.4998 0.825464 12 5.50063C7.50016 0.825464 2 4.27416 2 9.1371Z"
            fill={active ? '#66a589' : '#69686f'}
        />
    </svg>
);

const CategoryIcon = ({ active }) => (
    <svg
        width="20" height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.6695 2H16.7695C14.5895 2 13.4395 3.15 13.4395 5.33V7.23C13.4395 9.41 14.5895 10.56 16.7695 10.56H18.6695C20.8495 10.56 21.9995 9.41 21.9995 7.23V5.33C21.9995 3.15 20.8495 2 18.6695 2Z"
            fill={active ? '#66a589' : '#69686f'}
        />
        <path
            d="M7.24 13.4297H5.34C3.15 13.4297 2 14.5797 2 16.7597V18.6597C2 20.8497 3.15 21.9997 5.33 21.9997H7.23C9.41 21.9997 10.56 20.8497 10.56 18.6697V16.7697C10.57 14.5797 9.42 13.4297 7.24 13.4297Z"
            fill={active ? '#66a589' : '#69686f'}
        />
        <path
            d="M6.29 10.58C8.6593 10.58 10.58 8.6593 10.58 6.29C10.58 3.9207 8.6593 2 6.29 2C3.9207 2 2 3.9207 2 6.29C2 8.6593 3.9207 10.58 6.29 10.58Z"
            fill={active ? '#66a589' : '#69686f'}
        />
        <path
            d="M17.7099 22.0019C20.0792 22.0019 21.9999 20.0812 21.9999 17.7119C21.9999 15.3426 20.0792 13.4219 17.7099 13.4219C15.3406 13.4219 13.4199 15.3426 13.4199 17.7119C13.4199 20.0812 15.3406 22.0019 17.7099 22.0019Z"
            fill={active ? '#66a589' : '#69686f'}
        />
    </svg>

)

const OrderIcon = ({ active }) => (
    <svg
        fill={active ? '#66a589' : '#69686f'}
        width="20" height="20"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M21,8h-.106A4.192,4.192,0,0,0,21,7a3.718,3.718,0,0,0-4-4c-2.164,0-3.969,2.271-5,3.928C10.969,5.271,9.164,3,7,3A3.718,3.718,0,0,0,3,7a4.192,4.192,0,0,0,.106,1H3A1,1,0,0,0,2,9v3a1,1,0,0,0,1,1h8V10h2v3h8a1,1,0,0,0,1-1V9A1,1,0,0,0,21,8ZM7.556,8C5,8,5,7.6,5,7,5,5.207,6.142,5,7,5c1.113,0,2.419,1.583,3.308,3Zm8.888,0H13.692c.889-1.417,2.2-3,3.308-3,.858,0,2,.207,2,2C19,7.6,19,8,16.444,8ZM13,15h7v5a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V15h7v4h2Z" />
    </svg>

)

const ProfileIcon = ({ active }) => (
    <svg
        width="20" height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="style=fill">
            <g id="profile">
                <path
                    id="vector (Stroke)"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.75 6.5C6.75 3.6005 9.1005 1.25 12 1.25C14.8995 1.25 17.25 3.6005 17.25 6.5C17.25 9.3995 14.8995 11.75 12 11.75C9.1005 11.75 6.75 9.3995 6.75 6.5Z"
                    fill={active ? '#66a589' : '#69686f'}
                />
                <path
                    id="rec (Stroke)"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.25 18.5714C4.25 15.6325 6.63249 13.25 9.57143 13.25H14.4286C17.3675 13.25 19.75 15.6325 19.75 18.5714C19.75 20.8792 17.8792 22.75 15.5714 22.75H8.42857C6.12081 22.75 4.25 20.8792 4.25 18.5714Z"
                    fill={active ? '#66a589' : '#69686f'}
                />
            </g>
        </g>
    </svg>

);

const tabs = [
    { path: "/", icon: HomeIcon, label: "Home" },
    { path: "/custom-order", icon: CategoryIcon, label: "Custom" },
    { path: "/cart", icon: CartIcon, label: "Cart" },
    { path: "/account/all-order", icon: OrderIcon, label: "Orders" },
    { path: "/account", icon: ProfileIcon, label: "Profile" },

    // { path: "/wishlist", icon: "fi fi-rr-heart", label: "Wishlist" },
    // { path: "/cart", icon: "fi fi-rr-shopping-cart", label: "Cart" },
    // { path: "/category", icon: "fi fi-rr-document-signed", label: "Category" },
    // { path: "/profile", icon: "fi fi-rr-user", label: "Profile" },
];

export default function Navbar() {
    const location = useLocation(); // ✅ ADD THIS

    return (
        <div
            className="position-fixed w-100 bottom-0 start-0 bg-white p-2 pb-4" style={{ zIndex: '99' }}>
            <div className="d-flex justify-content-between px-3"  >
                {tabs.map((tab) => {
                    const active = location.pathname === tab.path;

                    return (
                        <NavLink
                            key={tab.path}
                            to={tab.path}
                            className={`nav-item active-nav`}
                        >
                            <tab.icon active={active} />
                            <span className="navlabel small"> {tab.label} </span>
                        </NavLink>
                    );
                })}

            </div>
        </div>
    );
}
